module.exports = __webpack_public_path__ + "media/images/contact-bg-light-1de952b17d17931aa7dd540df574feaa.svg";